module.exports = __webpack_public_path__ + "662edba2bbd499839d4100bec2ac375b.svg";